import { Code } from "../../../api/get-notification-template-properties-by-code/get-notification-template-properties-by-code";
import { PropertyTreeByCode } from "./property-tree-by-code";
import { PropertyTreeByNotificationTemplate } from "./property-tree-by-notification-template-id";

export function PropertyTree({
  templateId,
  code,
}: {
  templateId?: string;
  code?: Code;
}) {
  if (templateId) {
    return <PropertyTreeByNotificationTemplate id={templateId} />;
  }

  if (code) {
    return <PropertyTreeByCode code={code} />;
  }

  return null;
}
